module.exports = __webpack_public_path__ + "img/smoke_shop_5.b9fceafa.png";